import React, {Component} from 'react'

import TodoTaxReports from 'Todo/views/TodoErrorEventsView/containers/Smartphones'
import IpadNavigation from 'Navigation/IpadNavigation'

export default class TodoReportsView extends Component {
  render () {
    return (
      <IpadNavigation {...this.props} onlyLeftSide setCurrentLink>
        <TodoTaxReports {...this.props} />
      </IpadNavigation>
    )
  }
}
